export class UnStructuredUtil {
  static readContent(fileBlob?: Blob): Promise<any[]> {
    return new Promise<Array<any>>((resolve, reject) => {
      if (!fileBlob) {
        resolve([]);
        return;
      }
      const fileReader = new FileReader();
      fileReader.onload = function (event) {
        const text = event.target?.result; // 从 Blob 中读取的字符串数据
        const data = UnStructuredUtil.handleFileData(text);
        resolve(data);
      };
      fileReader.onerror = function () {
        reject("error");
      };
      fileReader.readAsText(fileBlob);
    });
  }

  static handleFormatData(fileList: any) {
    const arr: any = [];

    fileList.forEach((x: any) => {
      let item: any = {};
      try {
        item = JSON.parse(x);
      } catch (error) {}
      const result = item?.text;
      if (item.type === "NarrativeText") {
        if (arr[arr.length - 1]?.type === "NarrativeText") {
          arr[arr.length - 1].text += ` ${result}`;
        } else {
          arr.push({
            text: result,
            type: "NarrativeText",
          });
        }
      } else if (item.type) {
        arr.push({
          text: result,
          type: item.type,
        });
      }
    });
    return arr;
  }

  static handleFileData(text: any): any[] {
    const fileList: any[] = [];
    const t1 = text.split("\n");

    t1.forEach((x: any) => {
      if (x) {
        fileList.push(x);
      }
    });
    return this.handleFormatData(fileList);
  }
}
